import cn from "classnames"
import React from "react"

import { StyledLink } from "~/components/Helpers/StyledLink/StyledLink"

import styles from "./index.module.css"

export const MenuLink = ({ children, href, className, as }) => (
  <div className={styles.Wrapper}>
    <StyledLink as={as} className={cn(className, styles.Link)} href={href}>
        <span>{children}</span>
    </StyledLink>
  </div>
)
